import React, { useState, useEffect } from 'react';
import { IndicadoresProd } from './Indicadores';
import { TablaGeneral } from './InventarioGeneral';
import {
  getAllIndicators,
  getAllPackages,
} from '../../../../service/inventario/productos';

type TotalesItem = {
  status_id: number;
  name: string;
  total: number;
  count: number;
};

type DataSends = {
  total: number;
  totales: TotalesItem[];
};

const View: React.FC = () => {
  const [dataSends, setDataSends] = useState<DataSends | null>(null);
  const [listPackages, setListPackages] = useState<any[]>([]);

  const [loadingView, setLoadingView] = useState<number>();
  const [statusFilter, setStatusFilter] = useState<number>(0);
  const [serchFilter, setSerchFilter] = useState<string>('');

  const fetchPost = async () => {
    const filters = { type_stock: statusFilter };

    try {
      const sends = await getAllIndicators(filters);
      if (sends) {
        setDataSends(sends);
      }
    } catch (error) {
      console.error('Error al obtener datos:', error);
    }
  };

  const fetchPostPackage = async () => {
    setListPackages([]);
    const filters = { type_stock: statusFilter, search: serchFilter };

    try {
      const packages = await getAllPackages(filters);
      if (packages) {
        setListPackages(packages);
      }
    } catch (error) {
      console.error('Error al obtener datos:', error);
    }
  };

  const handleFilter = (values: any) => {
    setSerchFilter(values);
  };

  useEffect(() => {
    fetchPostPackage();
    fetchPost();
  }, [serchFilter, statusFilter, loadingView]);

  return (
    <>
      {/* <div className="row w-100 mb-5">
        <ul className="nav justify-content-center align-items-center w-100 d-flex">
          {[
            { label: 'Todo', value: 0 },
            { label: 'SIM', value: 1 },
            { label: 'E-SIM', value: 2 },
          ].map(({ label, value }) => (
            <li
              key={value}
              className="nav-item bg-white flex-fill text-center"
              style={{ maxWidth: '120px' }}
            >
              <a
                className={`nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bold ${
                  statusFilter === value ? 'active' : ''
                }`}
                onClick={() => setStatusFilter(value)}
              >
                {label}
              </a>
            </li>
          ))}
        </ul>
      </div> */}
      <IndicadoresProd dataIndicators={dataSends} />
      <TablaGeneral
        onReloadData={(reload: boolean) => {
          if (reload) {
            setLoadingView(Math.random() * 40);
          }
        }}
        listaPaquetes={listPackages}
        onSearchFilter={handleFilter}
      />
    </>
  );
};

export { View };
